'use client';

import clsx from 'clsx';
import FAQ, { type FAQItem } from '@/components/section/faq/Faq';
import { Heading2 } from '@/components/section/headings';

export type HomeFaqPreviewSectionProps = {
  title: string;
  subtitle?: string;
  items: readonly FAQItem[];
  sectionId?: string;
  faqItemIdPrefix?: string;
  className?: string;
};

/**
 * Short FAQ accordion for the home page (full FAQ page can expand on the same items).
 */
const HomeFaqPreviewSection: React.FC<HomeFaqPreviewSectionProps> = ({
  title,
  subtitle,
  items,
  sectionId,
  faqItemIdPrefix,
  className,
}) => {
  return (
    <section
      id={sectionId}
      className={clsx('container-section', className)}
      aria-labelledby="home-faq-heading"
    >
      <div className="page-heading-wrap">
        <div id="home-faq-heading">
          <Heading2
            title={title}
            subtitle={subtitle}
            titleClassName="text-prose"
            subtitleClassName="mt-3 text-prose-muted"
          />
        </div>
      </div>
      <FAQ type="accordion" items={[...items]} itemIdPrefix={faqItemIdPrefix} />
    </section>
  );
};

export default HomeFaqPreviewSection;
